// 智能客服总开关：由环境变量 VITE_CUSTOMER_SERVICE_ENABLED 控制。
// 未配置时默认开启；需要关闭时显式设置为 '0' / 'false' / 'off' / 'no'。
//
// 注意：这是构建期开关，改动后需要重新构建/部署前端才生效（.env 不会被热更新）。
// 后续若需要“后端实时开关”（公共参数 KHPT_JQR，改数据库即可、无需重启/重发版），
// 需要后端提供一个免登录可读的白名单接口，详见交付说明。
const parseEnabled = (value) => {
  const normalized = String(value ?? "")
    .trim()
    .toLowerCase();

  if (!normalized) {
    return true;
  }

  return !["0", "false", "off", "no"].includes(normalized);
};

export const CUSTOMER_SERVICE_CONFIG = {
  enabled: parseEnabled(import.meta.env.VITE_CUSTOMER_SERVICE_ENABLED),
  script: import.meta.env.VITE_CUSTOMER_SERVICE_SCRIPT || "",
};
